import $ from 'jquery';

export default function restaurantTakeoutPage() {
    var $bottomSectionElement = $('#restaurantTakeoutPageBottomSection');

    if ($bottomSectionElement[0]) {
        $('.n-top-tabs-main').on('click', '.n-top-tab-item', function () {
            $bottomSectionElement.css('display', 'none');
        });
    }
}
